import MainAboutUs from "../components/about-us/MainAboutUs";

function SobreNosotros() {
  return <MainAboutUs />;
}

export default SobreNosotros;
